import {
  Paper,
  Button,
  Box,
  Typography,
  Grid,
  CircularProgress,
  Chip,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import SendIcon from "@mui/icons-material/Send";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./MailFlow.css";

const MailStatusDisplay = ({ data, isLoading }) => {
  const mailFlow = data || {
    mail_sent: "--",
    mail_sent_time: "--",
    mail_received: "--",
    mail_received_time: "--",
  };

  const getStatusIcon = (status) => {
    if (status === "Success") return <CheckCircleIcon color="success" />;
    if (status === "Failure" || status === "Error") return <ErrorIcon color="error" />;
    if (status === "--") return <PendingIcon color="warning" className="pulse-animation" />;
    return <CircularProgress size={20} />;
  };

  return (
    <Box className="mail-flow-container" sx={{ width: "100%", mt: 2 }}>
      <Box sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", sm: "row" }, 
        justifyContent: "space-between", 
        alignItems: { xs: "flex-start", sm: "center" }, 
        gap: 2,
        mb: 3 
      }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary", fontSize: { xs: "1rem", sm: "1.25rem" } }}>
          Test Results
        </Typography>
        <Chip
          label={mailFlow.mail_received === "Success" ? "Test Completed" : "Testing in Progress..."}
          color={mailFlow.mail_received === "Success" ? "success" : "primary"}
          variant="outlined"
          size="small"
        />
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Paper elevation={0} variant="outlined" className="status-card" sx={{ p: { xs: 1.5, sm: 2 }, bgcolor: "background.paper" }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
              <SendIcon sx={{ mr: 1, color: "primary.main", fontSize: "1.2rem" }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Outgoing Status</Typography>
            </Box>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="caption" color="text.secondary">Status</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  {getStatusIcon(mailFlow.mail_sent)}
                  <Typography variant="body2" className={`status-${mailFlow.mail_sent === "Success" ? "success" : "pending"}`} sx={{ fontSize: "0.85rem" }}>
                    {mailFlow.mail_sent === "Success" ? "Sent" : mailFlow.mail_sent}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ textAlign: "right" }}>
                <Typography variant="caption" color="text.secondary">Time</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.8rem" }}>
                  {mailFlow.mail_sent_time || "--"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper elevation={0} variant="outlined" className="status-card" sx={{ p: { xs: 1.5, sm: 2 }, bgcolor: "background.paper" }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
              <MarkEmailReadIcon sx={{ mr: 1, color: "secondary.main", fontSize: "1.2rem" }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Incoming Status</Typography>
            </Box>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="caption" color="text.secondary">Status</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  {getStatusIcon(mailFlow.mail_received)}
                  <Typography variant="body2" className={`status-${mailFlow.mail_received === "Success" ? "success" : "pending"}`} sx={{ fontSize: "0.85rem" }}>
                    {mailFlow.mail_received === "Success" ? "Received" : mailFlow.mail_received}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ textAlign: "right" }}>
                <Typography variant="caption" color="text.secondary">Time</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.8rem" }}>
                  {mailFlow.mail_received_time || "--"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MailStatusDisplay;
